import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule } from 'ng-recaptcha';
import { TagInputModule } from 'ngx-chips';
import { NgxPowerBiModule } from 'ngx-powerbi';

import { ContactService } from 'src/services/contact/contact.service';
import { LoginService } from 'src/services/login/login.service';
import { UserService } from 'src/services/user/user.service';
import { TaskService } from 'src/services/task/task.service';
import { PBIService } from 'src/services/pbi/pbi.service';
import { KPIService } from 'src/services/kpi/kpi.service';
import { HttpLogado } from 'src/services/HttpLogado';
import { LocalStorageService } from 'src/services/local-storage/local-storage.service';
import { SessionStorageService } from 'src/services/session-storage/session-storage.service';
import { PaymentService } from 'src/services/payment/payment.service';
import { PlanService } from 'src/services/plan/plan.service';

import { MenuComponent } from './menu/menu.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ContactListPageComponent } from './contact-list-page/contact-list-page.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { TaskListPageComponent } from './task-list-page/task-list-page.component';
import { PbiConnectionPageComponent } from './pbi-connection-page/pbi-connection-page.component';
import { PasswordPageComponent } from './password-page/password-page.component';
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './reset-password-page/reset-password-page.component';
import { HeaderComponent } from './header/header.component';
import { AccountPageComponent } from './account-page/account-page.component';
import { EditTaskPageComponent } from './edit-task-page/edit-task-page.component';
import { TaskProgressComponent } from './task-progress/task-progress.component';
import { TaskFormComponent } from './edit-task-page/task-form/task-form.component';
import { TaskStepConfigComponent } from './edit-task-page/task-form/task-step-config/task-step-config.component';
import { TaskStepDataComponent } from './edit-task-page/task-form/task-step-data/task-step-data.component';
import { TaskStepDeliveryComponent } from './edit-task-page/task-form/task-step-delivery/task-step-delivery.component';
import { TaskStepScheduleComponent } from './edit-task-page/task-form/task-step-schedule/task-step-schedule.component';
import { TaskRevisionComponent } from './edit-task-page/task-form/task-revision/task-revision.component';
import { DeliveryFormModalComponent } from './edit-task-page/task-form/task-step-delivery/delivery-form-modal/delivery-form-modal.component';
import { AutocompleteTextareaComponent } from './autocomplete-textarea/autocomplete-textarea.component';
import { ConfirmActionModalComponent } from './confirm-action-modal/confirm-action-modal.component';
import { ConfirmDeletionModalComponent } from './confirm-deletion-modal/confirm-deletion-modal.component';
import { ContactInputComponent } from './contact-input/contact-input.component';
import { ScheduleFormModalComponent } from './schedule-form-modal/schedule-form-modal.component';
import { HourMinuteInputComponent } from './hour-minute-input/hour-minute-input.component';
import { MonthDayInputComponent } from './month-day-input/month-day-input.component';
import { WeekdaySelectInputComponent } from './weekday-select-input/weekday-select-input.component';
import { DayHourInputComponent } from './day-hour-input/day-hour-input.component';
import { TreeViewComponent } from './tree-view/tree-view.component';
import { PbiReportViewComponent } from './pbi-report-view/pbi-report-view.component';
import { ContactFormModalComponent } from './contact-list-page/contact-form-modal/contact-form-modal.component';
import { ConnectionWizardComponent } from './connection-wizard/connection-wizard.component';
import { ConnectionStepAComponent } from './connection-wizard/connection-step-a/connection-step-a.component';
import { ConnectionStepBComponent } from './connection-wizard/connection-step-b/connection-step-b.component';
import { ConnectionProgressComponent } from './connection-wizard/connection-progress/connection-progress.component';
import { MinimalistEntryComponent } from './minimalist-entry/minimalist-entry.component';
import { ConnectionStepCComponent } from './connection-wizard/connection-step-c/connection-step-c.component';
import { ConnectionStepDComponent } from './connection-wizard/connection-step-d/connection-step-d.component';
import { KPICardComponent } from './dashboard-page/kpi-card/kpi-card.component';
import { PlanCardComponent } from './dashboard-page/plan-card/plan-card.component';
import { DashboardEventGraphComponent } from './dashboard-page/dashboard-event-graph/dashboard-event-graph.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { LogPageComponent } from './log-page/log-page.component';
import { KothingHtmlEditorComponent } from './kothing-html-editor/kothing-html-editor.component';
import { FilterablePaginatedTableComponent } from './filterable-paginated-table/filterable-paginated-table.component';
import { BulkSendPdfPasswordModalComponent } from './contact-list-page/bulk-send-pdf-password-modal/bulk-send-pdf-password-modal.component';
import { WelcomeScreenComponent } from './dashboard-page/welcome-screen/welcome-screen.component';
import { AdminBillingPageComponent } from './admin-billing-page/admin-billing-page.component';
import { UserBillingPageComponent } from './user-billing-page/user-billing-page.component';
import { AdminTestPageComponent } from './admin-test-page/admin-test-page.component';
import { EditPlanDetailsPageComponent } from './edit-plan-details-page/edit-plan-details-page.component';
import { PlanViewComponent } from './edit-plan-details-page/plan-view/plan-view.component';
import { PaymentMethodFormComponent } from './edit-plan-details-page/payment-method-form/payment-method-form.component';
import { PersonalDetailsFormComponent } from './account-page/personal-details-form/personal-details-form.component';
import { EmailConfigurationFormComponent } from './account-page/email-configuration-form/email-configuration-form.component';
import { VideoModalComponent } from './video-modal/video-modal.component';
import { TagListInputComponent } from './tag-list-input/tag-list-input.component';
import { ExpirationNoticeModalComponent } from './dashboard-page/expiration-notice-modal/expiration-notice-modal.component';
import { ActivePageComponent } from './active-page/active-page.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    ForgotPasswordPageComponent,
    ContactListPageComponent,
    MenuComponent,
    DashboardPageComponent,
    TaskListPageComponent,
    PbiConnectionPageComponent,
    PasswordPageComponent,
    ResetPasswordPageComponent,
    HeaderComponent,
    AccountPageComponent,
    EditTaskPageComponent,
    TaskProgressComponent,
    TaskFormComponent,
    TaskStepDeliveryComponent,
    TaskStepConfigComponent,
    TaskStepDataComponent,
    TaskStepScheduleComponent,
    TaskRevisionComponent,
    DeliveryFormModalComponent,
    ScheduleFormModalComponent,
    AutocompleteTextareaComponent,
    ConfirmActionModalComponent,
    ConfirmDeletionModalComponent,
    ContactInputComponent,
    HourMinuteInputComponent,
    MonthDayInputComponent,
    WeekdaySelectInputComponent,
    DayHourInputComponent,
    TreeViewComponent,
    PbiReportViewComponent,
    ContactFormModalComponent,
    ConnectionWizardComponent,
    ConnectionStepAComponent,
    ConnectionStepBComponent,
    ConnectionProgressComponent,
    ConnectionStepCComponent,
    ConnectionStepDComponent,
    MinimalistEntryComponent,
    KPICardComponent,
    PlanCardComponent,
    DashboardEventGraphComponent,
    RegisterPageComponent,
    LogPageComponent,
    KothingHtmlEditorComponent,
    FilterablePaginatedTableComponent,
    BulkSendPdfPasswordModalComponent,
    WelcomeScreenComponent,
    AdminBillingPageComponent,
    UserBillingPageComponent,
    AdminTestPageComponent,
    EditPlanDetailsPageComponent,
    PlanViewComponent,
    PaymentMethodFormComponent,
    PersonalDetailsFormComponent,
    EmailConfigurationFormComponent,
    VideoModalComponent,
    TagListInputComponent,
    ExpirationNoticeModalComponent,
    ActivePageComponent
  ],
  imports: [
    NgbModule,
    NgbModalModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxPowerBiModule,
    ReactiveFormsModule,
    RecaptchaModule,
    TagInputModule
  ],
  entryComponents: [
    DeliveryFormModalComponent,
    ScheduleFormModalComponent,
    ConfirmActionModalComponent,
    ConfirmDeletionModalComponent,
    ContactFormModalComponent,
    BulkSendPdfPasswordModalComponent,
    VideoModalComponent,
    ExpirationNoticeModalComponent
  ],
  providers: [
    HttpLogado,
    LoginService,
    ContactService,
    UserService,
    TaskService,
    PBIService,
    KPIService,
    LocalStorageService,
    SessionStorageService,
    PaymentService,
    PlanService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
